import * as t from "io-ts";
import { FinanceProvider } from "./FinanceProvider";
import { Metadata } from "./Metadata";
import { Pence } from "./Pence";

export const Transaction = t.intersection([
  t.type({
    id: t.string,
    lender: FinanceProvider,
    xid: t.string,
    payout_type: t.union([
      t.literal("paid_to_kanda"),
      t.literal("paid_from_kanda"),
    ]),
    payout_date: t.string,
    amount: Pence,
    vat: Pence,
    fee: Pence,
  }),
  t.partial({
    xref: t.string,
    account_name: t.string,
    note: t.string,
    metadata: Metadata,
  }),
]);

export interface Transaction {
  id: string;
  lender: FinanceProvider;
  xid: string;
  xref?: string;
  account_name?: string;
  payout_type: "paid_to_kanda" | "paid_from_kanda";
  payout_date: string;
  amount: Pence;
  vat: Pence;
  fee: Pence;
  note?: string;
  metadata?: Metadata;
}
